import * as React from "react";
import { BaseDict } from "./dict";
import { Tabs, TabBlock, TabsBlocks, TabTrigger, TabsTriggers } from "sb-resp-lib";
// external components
import { HamburgerNavigationIcon } from "../../components"

export class HamburgerNavigationTabSwitcherBlock extends React.Component<{
    dict: BaseDict,
    cms: any
}, {
    tabActive: string
}> {
    dict: BaseDict;
    tabsInstances: {};
    cms: any;
    childrenConfig: any;
    tabTriggers: any;
    tabBlocks: any;

    constructor(props) {
        super(props);

        // setup dictionary
        this.dict = this.props.dict;

        this.childrenConfig = this.props.cms.Children;
        this.tabsInstances = {};
        this.tabTriggers = [];
        this.tabBlocks = [];

        // setup default active tab
        this.state = {
            tabActive: this.childrenConfig[0].BlockUniqueID
        }

        this.initiateTabSwitcherChildren();
    }

    /* istanbul ignore next */
    componentDidMount() {
        this.tabsInstances[this.state.tabActive].activate();
    }

    /* istanbul ignore next */
    initiateTabSwitcherChildren() {
        this.childrenConfig.forEach(function (child) {
            let id = child.BlockUniqueID;
            this.tabsInstances[id] = child.Block;
            this.tabTriggers.push(this.renderTabTrigger(child));
            this.tabBlocks.push(this.renderTabBlock(child));
        }, this);
    }

    /* istanbul ignore next */
    callTab(tabId) {
        if (tabId === this.state.tabActive) { return; }

        Object.keys(this.tabsInstances).forEach(x => this.tabsInstances[x][x === tabId ? "activate" : "deactivate"]());
        this.setState({
            tabActive: tabId
        });
    }

    /* istanbul ignore next */
    renderTabTrigger(child) {
        const id = child.BlockUniqueID;
        const iconClass = "rj-hamburger-tabs-01-icon";

        return (
            <div key={id} className="rj-hamburger-tabs-01-outer" onClick={() => this.callTab(id)}>
                <TabTrigger default={this.state.tabActive === id} link={id}>
                    <a className="rj-hamburger-tabs-01">
                        <HamburgerNavigationIcon iconId={child.IconID} cmsClass={child.IconDefaultClass} modifier={iconClass} />
                        <span className="rj-hamburger-tabs-01-title">{child.Title}</span>
                    </a>
                </TabTrigger>
            </div>
        )
    }

    /* istanbul ignore next */
    renderTabBlock(child) {
        const id = child.BlockUniqueID;
        return (
            <TabBlock key={id} link={id}><div id={id}></div></TabBlock>
        )
    }

    render() {
        return (
            <div className="rj-hamburger-tab-switcher-block">
                <Tabs>
                    <div className="rj-hamburger-tabs-container">
                        <div className="rj-hamburger-tabs-01-container">
                            <TabsTriggers>
                                {this.tabTriggers}
                            </TabsTriggers>
                        </div>
                        <div className="rj-hamburger-tabs-01-blocks rj-hamburger-tabs-scrolling">
                            <TabsBlocks>
                                {this.tabBlocks}
                            </TabsBlocks>
                        </div>
                    </div>
                </Tabs>
            </div>
        )
    }
}